'use strict';

/**
 * shopspace.service module
 *
 * This file defines the Angular module. All sub-modules in services/, configurers/,
 * filters/, and renderers/ are loaded automatically by main.js via import.meta.glob().
 *
 * The sub-modules use angular.module('shopspace.service') (getter) to add their
 * factories/services/filters to this module.
 */
angular.module('shopspace.service', [
  'restangular',
  'ngFileSaver'
]);
